import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'light' | 'dark' | 'auto';
export type MenuSide = 'left' | 'right';

interface ThemeState {
  mode: ThemeMode;
  menuSide: MenuSide;
  setMode: (mode: ThemeMode) => void;
  setMenuSide: (side: MenuSide) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'auto',
      menuSide: 'right',
      setMode: (mode) => set({ mode }),
      setMenuSide: (menuSide) => set({ menuSide }),
    }),
    { name: 'playground-theme' },
  ),
);
